import api from './api';

const getUserRbac = async () => {
  try {
    const client = await api('corporate');
    const { data } = await client.get('/user/rb');

    if (data.length === 0) {
      return [{
        produto: '5e0804f40bb53544bb474e5d',
        aplicacao: '5efe1170c9c43a30a12ca454',
        roles: [
          'parametrizacoes',
          'parametrizacoes',
          'parametrizacoes-gestaopendencias',
          'parametrizacoes-parametrizacoes',
          'parametrizacoes-controle-de-acesso',
          'parametrizacoes-service-desk',
          'parametrizacoes-transportadora',
          'parametrizacoes-seguranca-corporativa',
          'parametrizacoes-gestao-pendencias',
          'parametrizacoes-convenios',
          'parametrizacoes-avaliacao-conformidade',
          'parametrizacoes-cadastro-correspondente-bancos',
          'parametrizacoes-cadastro-correspondente-cnae',
          'parametrizacoes-cadastro-correspondente-palavras-impeditivas',
          'parametrizacoes-cadastro-correspondente',
          'parametrizacoes-formalizacao-sla',
          'parametrizacoes-formalizacao',
          'parametrizacoes',
          'parametrizacoes',
        ],
      }];
    }

    console.log(data);

    // if (data.length === 0) return null;
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export {
  getUserRbac,
};
